'use client';
import G02D04PlaylistPage from '@/context/domain/g02/g02-d01/g02-d01-p004-playlist';

const PlayList = () => {
  return <G02D04PlaylistPage />;
};

export default PlayList;
